import { render, staticRenderFns } from "./disaster.vue?vue&type=template&id=4db219a1&scoped=true&"
import script from "./disaster.vue?vue&type=script&lang=js&"
export * from "./disaster.vue?vue&type=script&lang=js&"
import style0 from "./disaster.vue?vue&type=style&index=0&id=4db219a1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db219a1",
  null
  
)

export default component.exports